export class PhysicalEstablishment {
    code: string;
    name: string;
    address: string;
    city: string;
    country: string;

    constructor() {
        this.code = "";
        this.name = "";
        this.address = "";
        this.city = "";
        this.country = "";
    }
}